import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

import Button from 'react-bootstrap/lib/Button';
import withStyles from 'isomorphic-style-loader/withStyles';

import Image from '../WhyHostFormBlock1/Image';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';
import messages from '../../../../locale/jsonMessages';
import { formatLocaleData } from '../../../../helpers/formatLocale';

import submit from './submit';
import validate from './validate';

import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock3.css';

const block3ActiveFields = ['whyBlockTitle1', 'whyBlockContent1', 'whyBlockTitle2', 'whyBlockContent2'];

class WhyHostFormBlock3 extends Component {

  render() {

    const { error, handleSubmit, submitting, whyBlock1loader, whyBlock2loader, whyBlockImage1, whyBlockImage2, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage {...messages.WhyBecomeOwnerBlock3} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className='oneColumnGrid'>
            <div className="twoColumnGrid">
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /> 1</label>
                <Image image={whyBlockImage1} fieldName={"whyBlockImage1"} loader={whyBlock1loader} />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /> 2</label>
                <Image image={whyBlockImage2} fieldName={"whyBlockImage2"} loader={whyBlock2loader} />
              </div>
            </div>
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicWhyHostInfoBlock"
                component={FieldArrayComponent}
                activesFields={block3ActiveFields}
                filedName="dynamicWhyHostInfoBlock"
                selectedLanguage={selectedLanguage}
                label={formatMessage(messages.whyBlockTitleLabel1)}
                placeholder={formatMessage(messages.whyBlockTitleLabel1)}
                isDouble
              />
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

WhyHostFormBlock3 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock3);

const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  whyBlock1loader: state?.loader?.whyBlockImage1,
  whyBlock2Loader: state?.loader?.whyBlockImage2,
  whyBlockImage1: selector(state, 'whyBlockImage1'),
  whyBlockImage2: selector(state, 'whyBlockImage2'),
  selectedLanguage: selector(state, 'dynamicWhyHostInfoBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = {
};

export default compose(
  withStyles(cs, s),
  injectIntl,
  connect(mapState, mapDispatch)
)(WhyHostFormBlock3);
